export const HOME = '/'
export const PRICING = '/pricing'
export const CONTACTUS = '/contactus'
export const INVOICE = '/invoice'
